import { createRoutine } from 'redux-saga-routines';
import extendRoutine from 'utils/routines';

import { GET_INSTANCES, CREATE_INSTANCE, DELETE_INSTANCE } from './constants';

export const getInstances = extendRoutine(createRoutine(GET_INSTANCES), 'RESET');
export const createInstance = extendRoutine(createRoutine(CREATE_INSTANCE), 'RESET');
export const deleteInstance = extendRoutine(createRoutine(DELETE_INSTANCE), 'RESET');
